<div class="modal show fade in " *ngIf="showModal" tabindex="-1" role="dialog" data-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
        <button class="btn btn-default-reverse btn-block btn-sm" data-dismiss="modal" type="button" (click)="closeModal()">Chiudi</button>
      </p>
      <div class="col-sm-12 coldx">
        <h4 class="modal-title">Ricerca</h4>
      </div>
      <div class="row">
        <div class="form-group col-sm-12">
          <label for="cerca_libero">Cerca (testo libero)</label>
          <div class="input-group" autofocus>
            <input class="form-control" required placeholder="Es. Nome e Cognome, grado, tipo di pratica" type="text"
              id="testoLibero" name="testoLibero" [(ngModel)]="searchText">
            <span class="input-group-btn">
              <button class="btn btn-primary" type="button" (click)="searchText=''" style="font-size: 15px;line-height: 1.4;" [disabled]="!searchText"><span style="margin-left: -2px;" class="glyphicon glyphicon-trash"></span></button>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
          <div class=" col-sm-6 text-left">
              <button class="btn btn-success " type="button" [disabled]="!searchText" (click)="smartSearch()">Smart search (beta)</button>
            </div>
        <div class=" col-sm-6 text-right">
          <button class="btn btn-primary" style="margin-right: 10px;" type="button" [disabled]="!searchText" (click)="cerca('pratica')">Cerca pratiche</button>
          <button class="btn btn-primary" type="button" [disabled]="!searchText" (click)="cerca('documenti')">Cerca documenti</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade in" *ngIf="showModal"></div>
